import checkRolePermissions from '@/domains/permissions/checkRolePermissions';

const canBrowseLookupStrategiesByRole = () => {
  const result = checkRolePermissions(['lookupStrategies.browse']);
  return result.passed;
};

export default canBrowseLookupStrategiesByRole;
